import customFieldsConstants from '../../../constants/CustomFieldsConstants';
import UIConstants from '../../../constants/UIConstants';
import customFieldsService from '../../../services/CustomFieldsService';
import storeManager from '../../../store/StoreManager';
import DefaultThemeService from '../default/DefaultThemeServices';
import ceqRubricsLoader from './ceqRubricsLoader';
import customFieldSubTypes from '../../../constants/CustomFieldSubTypes';
import uiService from '../../../services/UIService';
import questionReader from '../../../store/readHelpers/QuestionReader';
import uiReader from '../../../store/readHelpers/uiReader';

export default class CeqService extends DefaultThemeService {
    performPostComponentMountActions(selector) {
        this.scaleContent(selector);
    }

    performPostComponentDidUpdate(selector) {
        this.scaleContent(selector);
    }

    isImageScalingSupportedSubType(customFields) {
        const subType = customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_SUB_TYPE);
        const scaleSupportedSubTypes = [
            customFieldSubTypes.b1PrelimLPart1Mc,
            customFieldSubTypes.a2KeyLPart1Mc,
        ];

        return scaleSupportedSubTypes.includes(subType);
    }

    scaleContent(selector) {
        const zoomFactor = this.getZoomFactor();
        if (zoomFactor === 1) {
            return true;
        }

        if (uiReader.supportsInteractionImageScaling()) {
            setTimeout(() => {
                this.scaleChoiceInteractionImages(selector, zoomFactor);
            }, 100);
        }

        return true;
    }

    scaleImage(imageId) {
        const zoomFactor = this.getZoomFactor();
        uiService.scaleImage(imageId, zoomFactor);
    }

    scaleChoiceInteractionImages(selector, zoomFactor) {
        const interactionImages = document.querySelectorAll(`${selector} .${UIConstants.SCALABLE_INTERACTION_IMAGE_CLASS} label img:not(.scaled)`);
        Array.from(interactionImages)
            .filter(image => !isNaN(image.width) && !isNaN(image.height))
            .forEach((image) => {
                const scaledWidth = image.width * zoomFactor;
                image.width = scaledWidth;
                image.height *= zoomFactor;
                if (image.style.width) {
                    image.style.width = `${scaledWidth}px`;
                }

                image.classList.add('scaled');
            });
    }

    isInlineChoiceImageScalingSupported({ customFields }) {
        return uiReader.supportsInteractionImageScaling() && this.isImageScalingSupportedSubType(customFields);
    }

    getZoomFactor() {
        const { ui: { zoomFactor } } = storeManager.getState();
        switch (zoomFactor) {
        case UIConstants.ZOOM_FACTOR.MEDIUM:
            return 19 / 16; // zoom-medium font size / regular font size
        case UIConstants.ZOOM_FACTOR.LARGE:
            return 22 / 16; // zoom-large font size / regular font size
        default:
            return 1;
        }
    }

    getQuestionRubricsContent(question) {
        return ceqRubricsLoader.getRubricsContent(question);
    }

    shouldAddExtraLineSpacing(question) {
        return questionReader.isInlineChoice(question);
    }
}
